import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import { PRIVATE_ROUTES_COMPLETE } from '@/navigation/privateRoutes';
import { useAuth } from '@/auth/AuthProvider';

import {
  CustomList,
  CustomListItem,
  IconContainer,
  TextContainer,
  TextLabel,
  CustomCollapse
} from './styles';

const SidebarMenuItems = () => {
  const [collapse, setCollapse] = useState<Record<string, boolean>>({});
  const history = useHistory();
  const { hasPermission } = useAuth();
  const currentPath = history.location.pathname;

  const handleToggleCollapse = (key?: string) => {
    if (!key) return;
    setCollapse(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Box sx={{ height: '100%' }}>
      <Box sx={{ height: 300, margin: '0 auto 16px' }}>
        <CustomList>
          {Object.entries(PRIVATE_ROUTES_COMPLETE).map(([key, option]) => {
            const hasSubItems = Array.isArray(option.sections) && option.sections.length > 0;
            const isCollapsed = collapse[option.colapse || ''];
            
            if (!hasSubItems) {
              const permission = hasPermission(key);
              if (permission.noScreen) return null;
              const noSubsSelected = currentPath === `/${option.navigation}`;

              return (
                <div key={`sidebar-${key}`}>
                  <CustomListItem
                    onClick={() => history.push(option.navigation || '/')}
                    selected={noSubsSelected}
                  >
                    <IconContainer selected={noSubsSelected}>
                      {option.icon}
                    </IconContainer>

                    <TextContainer selected={noSubsSelected}>
                      <TextLabel>{option.title}</TextLabel>
                    </TextContainer>
                  </CustomListItem>
                </div>
              );
            }

            const validSections = option?.sections?.filter(section =>
              !hasPermission(section.navigation.replace('/', '')).noScreen
            );
            
            if (validSections?.length === 0) return null;
            const isSelected = !!option?.sections?.find(s => `/${s.navigation}` === currentPath);
            
            return (
              <div key={`sidebar-collapse-${key}`}>
                <CustomListItem
                  onClick={() => handleToggleCollapse(option.colapse)}
                  selected={isSelected}
                >
                  <IconContainer>
                    {option.icon}
                  </IconContainer>
                  <TextContainer>
                    <TextLabel>{option.title}</TextLabel>
                  </TextContainer>
                  {isCollapsed ? <ExpandLess /> : <ExpandMore />}
                </CustomListItem>

                <CustomCollapse open={isCollapsed}>
                  {validSections?.map(section => {
                    const selected = currentPath === `/${section.navigation}`;

                    return (
                      <CustomList key={`sidebar-subitem-${section.title}`} disablePadding>
                        <CustomListItem
                          onClick={() => history.push(section.navigation)}
                          selected={selected}
                          subSection
                        >
                          <IconContainer selected={selected}>
                            {section.icon}
                          </IconContainer>
                          <TextContainer selected={selected}>
                            <TextLabel>{section.title}</TextLabel>
                          </TextContainer>
                        </CustomListItem>
                      </CustomList>
                    );
                  })}
                </CustomCollapse>
              </div>
            );
          })}
        </CustomList>
      </Box>
    </Box>
  );
};

export default SidebarMenuItems;